import { render, staticRenderFns } from "./DarfPayment.vue?vue&type=template&id=06061aef"
import script from "./DarfPayment.vue?vue&type=script&lang=js"
export * from "./DarfPayment.vue?vue&type=script&lang=js"
import style0 from "./DarfPayment.vue?vue&type=style&index=0&id=06061aef&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports